import mod from "-!./Dashboard.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Dashboard.js?vue&type=script&lang=js&external"